module.exports = __webpack_public_path__ + "static/media/map-pin-green.5176228e.svg";